import React, { useState } from "react";
import { Typography, Button, Select } from "components";
import { Formik, Form, FieldArray } from "formik";
import {
  isObjectValuesEmpty,
  capitalizeFirstLetter,
  setAlert,
} from "utils/helper";
import { deviceTypeOptions } from "utils/constants";
import addTerminalCTA from "../../../../assets/images/add-terminal.png";

const BulkRegistration = ({ registerTerminals }) => {
  const [currentDeviceColumn, setCurrentDeviceColumn] = useState(null);

  const defaultValues = {
    oem: "",
    terminalId: "",
    serialNumber: "",
    deviceType: "",
    imei: "",
  };

  const initialValues = {
    terminals: Array(5).fill(defaultValues),
  };

  const handleSubmit = ({ terminals }, resetForm, setSubmitting) => {
    const newTerminals = terminals.filter(
      (terminal) => !isObjectValuesEmpty(terminal)
    );
    if (newTerminals.length) {
      let validationStatus = true;

      newTerminals.forEach(({ oem, terminalId, serialNumber, deviceType }) => {
        if (!oem || !terminalId || !serialNumber || !deviceType) {
          validationStatus = false;
        }
      });
      if (validationStatus) {
        //if all checks pass
        registerTerminals(newTerminals, resetForm);
      } else {
        setAlert("Please make sure no required field is empty");
      }
    } else {
      setAlert("At least a terminal entry is required");
    }
    setSubmitting(false);
  };

  return (
    <div className="bulk-registration-container">
      <div className="row">
        <div className="col-2 px-2">
          <div className="bulk-register-label">
            <Typography component="h5" state="primary" variant="body0">
              S/N
            </Typography>
          </div>
        </div>
        <div className="col-2 px-2">
          <div className="bulk-register-label">
            <Typography component="h5" state="primary" variant="body0">
              OEM Name
              <Typography
                component="span"
                state="danger"
                style={{ marginTop: "-.3rem" }}
              >
                *
              </Typography>
            </Typography>
          </div>
        </div>
        <div className="col-2 px-2">
          <div className="bulk-register-label">
            <Typography component="h5" state="primary" variant="body0">
              Terminal ID
              <Typography
                component="span"
                state="danger"
                style={{ marginTop: "-.3rem" }}
              >
                *
              </Typography>
            </Typography>
          </div>
        </div>
        <div className="col-2 px-2">
          <div className="bulk-register-label">
            <Typography component="h5" state="primary" variant="body0">
              Serial Number
              <Typography
                component="span"
                state="danger"
                style={{ marginTop: "-.3rem" }}
              >
                *
              </Typography>
            </Typography>
          </div>
        </div>
        <div className="col-2 px-2">
          <div className="bulk-register-label">
            <Typography component="h5" state="primary" variant="body0">
              Device Type
              <Typography
                component="span"
                state="danger"
                style={{ marginTop: "-.3rem" }}
              >
                *
              </Typography>
            </Typography>
          </div>
        </div>
        <div className="col-2 px-2">
          <div className="bulk-register-label">
            <Typography component="h5" state="primary" variant="body0">
              Device IMEI
            </Typography>
          </div>
        </div>
      </div>
      <Formik
        initialValues={initialValues}
        enableReinitialize
        onSubmit={(values, { resetForm, setSubmitting }) => {
          handleSubmit(values, resetForm, setSubmitting);
        }}
      >
        {({ values, isSubmitting, getFieldProps }) => (
          <Form autoComplete="off">
            <FieldArray
              name="terminals"
              render={({ push, pop, form }) => (
                <div className="row">
                  {values.terminals.map((value, index) => (
                    <React.Fragment key={index}>
                      <div className="col-2 px-2">
                        <div className="bulk-register-label">
                          <Typography
                            component="h5"
                            state="primary"
                            variant="body0"
                          >
                            Terminal {index + 1}
                          </Typography>
                        </div>
                      </div>
                      <div
                        className="col-2 px-2"
                        onClick={() => setCurrentDeviceColumn(null)}
                      >
                        <input
                          type="text"
                          className="bulk-register-input"
                          name={`terminals[${index}].oem`}
                          {...getFieldProps(`terminals[${index}].oem`)}
                        />
                      </div>
                      <div
                        className="col-2 px-2"
                        onClick={() => setCurrentDeviceColumn(null)}
                      >
                        <input
                          type="text"
                          className="bulk-register-input"
                          name={`terminals[${index}].terminalId`}
                          {...getFieldProps(`terminals[${index}].terminalId`)}
                        />
                      </div>
                      <div
                        className="col-2 px-2"
                        onClick={() => setCurrentDeviceColumn(null)}
                      >
                        <input
                          type="text"
                          className="bulk-register-input"
                          name={`terminals[${index}].serialNumber`}
                          {...getFieldProps(`terminals[${index}].serialNumber`)}
                        />
                      </div>
                      <div
                        className="col-2 px-2 "
                        onClick={() => {
                          setCurrentDeviceColumn(index);
                        }}
                      >
                        <div className="device-type-field d-flex align-items-center justify-content-center px-3">
                          {currentDeviceColumn !== index ? (
                            <Typography>
                              {capitalizeFirstLetter(
                                form.values.terminals[index].deviceType
                              )}
                            </Typography>
                          ) : (
                            <Select
                              required={false}
                              name={`terminals[${index}].deviceType`}
                              className="bulk-register-select"
                              options={deviceTypeOptions}
                              {...getFieldProps(
                                `terminals[${index}].deviceType`
                              )}
                            />
                          )}
                        </div>
                        {/* <input
                          type="text"
                          className="bulk-register-input"
                          name={`terminals[${index}].deviceType`}
                          {...getFieldProps(`terminals[${index}].deviceType`)}
                        /> */}
                      </div>
                      <div
                        className="col-2 px-2"
                        onClick={() => setCurrentDeviceColumn(null)}
                      >
                        <input
                          type="text"
                          className="bulk-register-input"
                          name={`terminals[${index}].imei`}
                          {...getFieldProps(`terminals[${index}].imei`)}
                        />
                      </div>
                    </React.Fragment>
                  ))}
                  <div
                    className={`d-flex justify-content-${
                      20 - form.values.terminals.length >= 5 ? "between" : "end"
                    } align-items-center mt-4`}
                  >
                    {20 - form.values.terminals.length >= 5 && (
                      <div className="col-2">
                        <img
                          style={{ marginLeft: "2rem" }}
                          src={addTerminalCTA}
                          alt=""
                          className="cursor-pointer"
                          onClick={() => {
                            for (let i = 1; i <= 5; i++) {
                              push(defaultValues);
                            }
                          }}
                        />
                      </div>
                    )}

                    {form.values.terminals.length > 0 && (
                      <Typography
                        state="primary"
                        variant="body3"
                        className="cursor-pointer"
                        onClick={pop}
                      >
                        Click to Delete row
                      </Typography>
                    )}
                  </div>

                  <div className="bulk-registeration-cta">
                    <Button
                      type="submit"
                      label="Register Terminals"
                      fullWidth
                      loading={isSubmitting}
                      onClick={() => setCurrentDeviceColumn(null)}
                    />
                  </div>
                </div>
              )}
            />
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default BulkRegistration;
